<template>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
        <div class="row">
            <ValidationProvider class="col-md-6" name="Tanggal" rules="required" v-slot="{ errors }">
                <div class="form-group">
                    <label for="date">Tanggal <span class="text-danger">*</span></label>
                    <date-picker v-model="model.date" format="DD MMMM, YYYY" type="date" value-type="YYYY-MM-DD"
                        placeholder="Masukan tanggal" style="width: 100%;">
                    </date-picker>
                    <small class="text-danger">{{ errors[0] }}</small>
                </div>
            </ValidationProvider>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="">Type <span class="text-danger">*</span></label>
                    <div class="custom-radio-group d-flex">
                        <label class="custom-radio">
                            <input type="radio" value="in" v-model="model.type" @change="handleTypeChange('in')"/>
                            <span class="radio-circle"></span>
                            Masuk
                        </label>

                        <label class="custom-radio">
                            <input type="radio" value="out" v-model="model.type" @change="handleTypeChange('out')"/>
                            <span class="radio-circle"></span>
                            Keluar
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-md-6" v-if="model.type == 'out'">
                <div class="form-group">
                    <label for="">Status <span class="text-danger">*</span></label>
                    <div class="custom-radio-group d-flex">
                        <label class="custom-radio">
                            <input type="radio" value="Permintaan" name="status" v-model="model.request_type" />
                            <span class="radio-circle"></span>
                            Permintaan
                        </label>

                        <label class="custom-radio">
                            <input type="radio" value="Peminjaman" name="status" v-model="model.request_type" />
                            <span class="radio-circle"></span>
                            Peminjaman
                        </label>
                    </div>
                </div>
            </div>

            <ValidationProvider class="col-md-6" name="Link Bukti" rules="" v-slot="{ errors }">
                <div class="form-group">
                    <label for="">Link Bukti</label>
                    <input type="url" v-model="linkBukti" class="form-control" placeholder="Masukan URL"
                        @change="attachmentsInputed">
                    <small class="text-danger">{{ errors[0] }}</small>
                </div>
            </ValidationProvider>

            <ValidationProvider class="col-md-6" name="Jumlah" 
                :rules="jumlahRules" 
                v-slot="{ errors }"
                :custom-messages="{
                    max_value: 'Jumlah tidak boleh melebihi stok, saat ini tersedia ' + stock,
                }"
            >
                <div class="form-group">
                    <label for="">Jumlah</label>
                    <input type="text" v-model="model.qty" @input="filterNumber" class="form-control"
                        :class="{ 'is-invalid': errors[0] }" placeholder="Masukan jumlah">
                    <small class="text-danger">{{ errors[0] }}</small>
                </div>
            </ValidationProvider>

            <div class="col-md-6" v-if="model.type == 'in'">
                <ValidationProvider rules="required" name="Material dari" vid="fromField" v-slot="{ errors }"
                    :persist="true">
                    <div class="form-group">
                        <label for="">Material Dari <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }"
                            v-model="model.from">
                        <small class="text-danger">{{ errors[0] }}</small>
                    </div>
                </ValidationProvider>
            </div>

            <div class="col-md-6" v-if="model.type == 'out'">
                <ValidationProvider rules="required" name="Informasi yang mengambil" vid="toField" v-slot="{ errors }"
                    :persist="true">
                    <div class="form-group">
                        <label for="">Yang mengambil <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" v-model="model.to">
                        <small class="text-danger">{{ errors[0] }}</small>
                    </div>
                </ValidationProvider>
            </div>
        </div>

        <hr>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal">Batal</button>
            <button type="button" :disabled="invalid" @click="save()" class="btn btn-primary">
                {{ saving ? 'Menyimpan...' : 'Simpan' }}
            </button>
        </div>
    </ValidationObserver>

</template>

<script>
export default {
    name: 'FormRiwayat',
    components: {},
    props: {
        material_id: {
            type: [String, Number],
            default: null
        }
    },

    data() {
        return {
            saving: false,
            linkBukti: '',
            model: {
                date: '',
                type: 'in',
                qty: 0,
                attachments: [],
                request_type: '',
                from: '',
                to: '',
                material_id: this.material_id
            },
            material: {},
            stock: 0,
            type: '',
            mode: 'add',
        }
    },
    mounted() {
        if (this.material_id) {
            this.getMaterial()
        }
    },
    computed: {
        jumlahRules() {
            if (this.model.type === 'out') {
                return `required|min_value:1|max_value:${this.stock}`;
            } else {
                return 'required|min_value:1';
            }
        }
    },
    methods: {
        getMaterial() {
            this.axios.get('/materials/' + this.material_id)
                .then(res => {
                    this.material = res.data.data
                    this.stock = this.material.storage.stock
                })
                .catch(err => {
                    console.error(err)
                    this.$toast.error('Gagal mengambil data material')
                })
        },
        handleTypeChange(type) {
            this.model.type = type;
            if (type === 'in') {
                this.model.request_type = '';
                this.model.to = '';
            } else if (type === 'out') {
                this.model.from = '';
                this.model.request_type = "Permintaan";
            }
        },
        filterNumber(e) {
            const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
            this.model.qty = onlyNumbers;
        },
        attachmentsInputed() {
            this.model.attachments = []
            this.model.attachments.push(this.linkBukti)
        },
        editMode(item) {
            this.mode = 'edit'
            this.model.date = item.date
            this.model.type = item.type
            this.model.qty = item.qty
            this.model.request_type = item.request_type
            this.model.from = item.from
            this.model.to = item.to
            this.model.id = item.id
            this.linkBukti = item.attachments[0]
        },
        resetModel() {
            this.model = { date: '', type: 'in', qty: 0, attachments: [], material_id: this.material_id }
            this.linkBukti = ''
            this.mode = 'add'
        },
        save() {
            let _ = this
            _.saving = true
            const payload = { ..._.model };
            const url = _.mode == 'add' ? "/material-stock-movements" : "/material-stock-movements/" + _.model.id
            const method = _.mode == 'add' ? "post" : "put"
            _.axios({
                method: method,
                url: url,
                data: payload
            })
                .then(res => {
                    if (res.status) {
                        this.$emit('saved')
                        _.$toast.success('Data Berhasil Disimpan')
                    } else {
                        _.$toast.warning('Data Gagal Disimpan')
                    }
                    window.$('#modal-form-riwayat').modal('hide')
                    _.resetModel
                    _.$refs.observer.reset();
                    this.$emit('saved', res.data);
                    _.saving = false
                })
                .catch(err => {
                    _.saving = false
                    if (err.response.status === 422) {
                        _.$toast.warning('Periksa kembali isian anda')
                    } else {
                        _.resetModel
                        _.$refs.observer.reset();
                        _.$toast.warning('terjadi kesalahan')
                    }
                })
        },
        destroy(x) {
            let _ = this
            this.$swal.fire({
                title: 'Hapus Data Ini?',
                text: "Anda mungkin tidak akan mengembalikannya lagi!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#44A8BD',
                cancelButtonColor: '#D95E6A',
                confirmButtonText: 'Ya, Hapus!',
                cancelButtonText: 'Batal'
            }).then((result) => {
                if (result.value) {
                    _.axios.delete('/material-stock-movements/' + x.id)
                        .then(res => {
                            if (res.status) {
                                this.$emit('deleted')
                                _.$toast.success('Data Berhasil dihapus')
                            } else {
                                _.$toast.error('Oops terjadi kesalahan')
                            }
                        })
                        .catch(err => {
                            console.log(err.response)
                            _.$toast.error('Oops terjadi kesalahan')
                        })
                }
            })
        }
    },
    watch: {
    }
}
</script>

<style scoped>
/* custom radio input */
.custom-radio-group {
    display: flex;
    gap: 2rem;
    align-items: center;
}

.custom-radio {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    font-weight: 500;
}

.custom-radio input[type="radio"] {
    opacity: 0;
    position: absolute;
}

.radio-circle {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid #1592b4;
    border-radius: 50%;
    margin-right: 8px;
    position: relative;
    box-sizing: border-box;
}

.custom-radio input[type="radio"]:checked+.radio-circle::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: #1592b4;
    border-radius: 50%;
    transform: translate(-50%, -50%);
}
</style>